var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 31,
    viewBox: "0 0 26 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2724 10.5522C20.2223 13.221 20.84 20.4798 25.9697 22.7235C26.2257 23.1587 24.7921 25.7595 24.4638 26.3002C23.6045 27.7184 21.6139 30.5274 19.9272 30.8743C17.6517 31.3427 16.2354 29.9448 14.2029 29.7843C10.5415 29.4951 8.72893 32.8665 5.25127 29.4778C0.477445 24.827 -2.88738 13.4508 3.58188 8.90269C6.8628 6.59537 8.6783 7.63482 11.9939 8.57163C14.1682 9.18605 15.2995 8.04829 17.3406 7.61747C20.2961 6.99438 23.5828 7.95576 25.271 10.5522H25.2724Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1194 7.37448C12.8026 3.56508 15.8362 0.516113 19.4845 0C20.0126 3.49858 16.7374 7.50459 13.1209 7.37448H13.1194Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.e5387e1032e4679c67fa6109bc1ae67e.svg";
export { ForwardRef as ReactComponent };